<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";

export default {
  page: {
    title: "Edit Peserta",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Edit Peserta",
      items: [
        {
          text: "Master",
          href: "/",
        },
        {
          text: "User",
          href: "/master/peserta",
        },
        {
          text: "Edit Peserta",
          active: true,
        },
      ],
      // Catch Error Axios
      axiosCatchError: null,

      // variable Page
      id: this.$route.params.id,
      idPelaksanaan: this.$route.params.idPelaksanaan,
      user_username: null,
      user_email: null,
      no_wa: null,
      user_name: null,

      list_unit: [],
      list_jabatan: [],

      selected_unit: null,
      selected_jabatan: null,

      user_alamat_rumah: null,
      user_unit_organisasi: null,
      user_alamat_instansi: null,
      
    };
  },
  mounted() {
    this.getListUnit()
  },
  methods: {
    getListUnit() {
      let self = this
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      var config_list_role = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/ref-unit",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };
      axios(config_list_role)
        .then(function (response) {
          var response_data = response.data;
          var response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            self.list_unit = response.data.data.referensi;
            self.getListJenJabatan()
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getListJenJabatan() {
      let self = this
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      var config_list_role = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/ref-jenjang-jabatan",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };
      axios(config_list_role)
        .then(function (response) {
          var response_data = response.data;
          var response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            self.list_jabatan = response.data.data.referensi;
            self.getData()
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getData() {
      let self = this;
      // get data user
      var config = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/peserta",
        params: {
          id: self.id,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };
      axios(config)
        .then(function (response) {
          var response_data = response.data;
          var response_data_fix = response_data.data[0];
          if (response_data.meta.code == 200) {
            var data_edit = response_data_fix;

            self.user_username = data_edit.username;
            self.user_email = data_edit.email;
            self.no_wa = data_edit.mobile_phone;
            self.user_name = data_edit.name;
            self.user_alamat_rumah = data_edit.address;
            self.user_alamat_instansi = data_edit.alamat_instansi;
            self.user_unit_organisasi = data_edit.unit_organization;
            self.selected_unit = data_edit.unit_name != null ? { mu_id: data_edit.unit_id, mu_nama: data_edit.unit_name } : null
            self.selected_jabatan = data_edit.jabatan_name != null ? { mjj_id: data_edit.jabatan_id, mjj_jenjang: data_edit.jabatan_name } : null
            Swal.close();
          } else {
            Swal.close();
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          Swal.close();
        });
    },
    StoreData() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
      });

      var config_store_data = {
        method: "put",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/peserta",
        data: {
          id: self.id,
          username: self.user_username,
          email: self.user_email,
          no_wa: self.no_wa,
          name: self.user_name,
          alamat_rumah: self.user_alamat_rumah,
          alamat_instansi: self.user_alamat_instansi,
          unit_organization: self.user_unit_organisasi,
          selected_unit: JSON.stringify(self.selected_unit),
          selected_jabatan: JSON.stringify(self.selected_jabatan),
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config_store_data)
        .then(function (response) {
          console.log(response);
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Anda akan diarahkan ke halaman master peserta segera",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              Swal.close();
              self.$router.push({ name: "detail-pra-pembelajaran", params:{ id: self.idPelaksanaan } });
            }
          });
        })
        .catch(function (error) {
          self.axiosCatchError = error.response.data.data;
          Swal.close();
        });
    },
    inputFilePhoto() {
      let self = this;
      if ($("#formPhoto")[0].files[0]) {
        if ($("#formPhoto")[0].files[0].size < 2242880) {
          $("#uploadLoading").html(
            '<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>'
          );
          var urlres = process.env.VUE_APP_BACKEND_URL;
          var FormData = require("form-data");
          var data = new FormData();
          data.append("file", $("#formPhoto")[0].files[0]);
          var config = {
            method: "post",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
            data: data,
          };
          axios(config).then(function (response) {
            console.log(response.data.data.path_file);
            var path_file = response.data.data.path_file;
            urlres += path_file;
            $("#uploadLoading").html(
              '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
              urlres +
              '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
            );
            self.user_photo = path_file;
          });
        } else {
          alert("Max File 2 MB");
        }
      }
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <b-form class="p-2" @submit.prevent="StoreData">
            <div class="card-body">
              <div v-if="axiosCatchError">
                <div class="alert alert-danger" v-if="typeof axiosCatchError === 'string' ||
                  axiosCatchError instanceof String
                  ">
                  {{ axiosCatchError }}
                </div>
                <div class="alert alert-danger" role="alert" v-else>
                  <div v-for="(errorArray, idx) in axiosCatchError" :key="idx">
                    <div v-for="(allErrors, idx) in errorArray" :key="idx">
                      <span class="text-danger">{{ allErrors[0] }} </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <hr />
                  <b-form-group class="mb-3" label="Username" label-for="formrow-username-input">
                    <b-form-input id="formrow-username-input" placeholder="Masukkan Username..." type="text"
                      v-model="user_username"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group class="mb-3" label="Nama" label-for="formrow-nama-input">
                    <b-form-input id="formrow-nama-input" placeholder="Masukkan Nama..." type="text"
                      v-model="user_name"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group class="mb-3" label="Email" label-for="formrow-nama-input">
                    <b-form-input id="formrow-nama-input" placeholder="Masukkan Email..." type="text"
                      v-model="user_email"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group class="mb-3" label="Nomor Whatsapp" label-for="formrow-nama-input">
                    <b-form-input id="formrow-nama-input" placeholder="Masukkan Nomor Whatsapp..." type="text"
                      v-model="no_wa"></b-form-input>
                    <p>*Contoh: 628094xxx</p>
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <label for="">Unit</label>
                  <v-select class="mb-3" :options="list_unit" label="mu_nama" v-model="selected_unit"
                    placeholder="Pilih Unit">
                  </v-select>
                </div>
                <div class="col-md-12">
                  <label for="">Jabatan</label>
                  <v-select class="mb-3" :options="list_jabatan" label="mjj_jenjang" v-model="selected_jabatan"
                    placeholder="Pilih Jabatan">
                  </v-select>
                </div>
                <div class="col-md-12">
                  <b-form-group class="mb-3" label="Alamat Instansi" label-for="formrow-alamat-instansi-input">
                    <b-form-input id="formrow-alamat-instansi-input" placeholder="Masukkan Alamat Instansi..." type="text"
                      v-model="user_alamat_instansi"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group class="mb-3" label="Alamat Rumah" label-for="formrow-alamat-rumah-input">
                    <b-form-input id="formrow-alamat-rumah-input" placeholder="Masukkan Alamat Rumah..." type="text"
                      v-model="user_alamat_rumah"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group class="mb-3" label="Unit Organisasi" label-for="formrow-unit-organisasi-input">
                    <b-form-input id="formrow-unit-organisasi-input" placeholder="Masukkan Unit Organisasi..." type="text"
                      v-model="user_unit_organisasi"></b-form-input>
                  </b-form-group>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-md-6">
                  <div class="text-start">
                    <router-link :to="{ name: 'detail-pra-pembelajaran', params:{ id: idPelaksanaan } }" class="btn btn-warning"><i class="fa fa-arrow-left"></i>
                      Kembali</router-link>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="text-end">
                    <b-button type="reset" variant="danger"><i class="fa fa-redo-alt"></i> Reset</b-button>
                    &nbsp;
                    <b-button type="submit" variant="primary"><i class="fa fa-save"></i> Simpan</b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </Layout>
</template>
